var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.359375,
    y: 0.9375,
    width: 22.6406,
    height: 22.6406,
    rx: 4.11648,
    fill: "#DAE4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02917 8.05859C8.57292 11.1461 8.57292 13.2044 7.02917 16.2919H10.1167C12.6896 16.2919 15.7771 14.2336 17.3208 12.1753C15.7771 10.1169 12.6896 8.05859 10.1167 8.05859H7.02917ZM8.57292 9.08776H10.1167C11.9177 9.08776 14.3877 10.6315 15.9315 12.1753C14.3877 13.719 11.9177 15.2628 10.1167 15.2628H8.57292C9.29334 13.153 9.29334 11.1976 8.57292 9.08776Z",
    fill: "#0B1C56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrIcon);
export default __webpack_public_path__ + "static/media/orIcon.3b27013c1c5b150cbbd96e7251f886a9.svg";
export { ForwardRef as ReactComponent };